import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusIcon, EditIcon } from 'lucide-react';
import { DataTable, Column } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
import { mockProducts } from '../data/mockData';
import { Product } from '../types';
export function ProductList() {
  const navigate = useNavigate();
  const columns: Column<Product>[] = [{
    key: 'productCode',
    label: 'Code',
    render: p => <span className="font-medium text-indigo-600" data-id="element-1436">{p.productCode}</span>
  }, {
    key: 'productName',
    label: 'Product Name',
    render: p => <span className="font-medium text-gray-900" data-id="element-1437">{p.productName}</span>
  }, {
    key: 'productType',
    label: 'Type'
  }, {
    key: 'category',
    label: 'Category'
  }, {
    key: 'status',
    label: 'Status',
    render: p => <StatusBadge status={p.status} data-id="element-1438" />
  }];
  return <div className="space-y-6 h-full flex flex-col" data-id="element-1439">
      <div className="flex items-center justify-between" data-id="element-1440">
        <div data-id="element-1441">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1442">
            Product Configuration
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-1443">
            Manage product catalog and specifications.
          </p>
        </div>
        <button onClick={() => navigate('/products/create')} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-1444">
          <PlusIcon className="h-4 w-4 mr-2" data-id="element-1445" />
          New Product
        </button>
      </div>

      <div className="flex-1" data-id="element-1446">
        <DataTable columns={columns} data={mockProducts} keyExtractor={item => item.id} searchPlaceholder="Search products..." onRowClick={item => navigate(`/products/${item.id}/edit`)} actions={item => <div className="flex space-x-3 justify-end" data-id="element-1448">
              <button onClick={() => navigate(`/products/${item.id}/edit`)} className="text-indigo-600 hover:text-indigo-900" data-id="element-1449">
                <EditIcon className="h-4 w-4" data-id="element-1450" />
              </button>
            </div>} data-id="element-1447" />
      </div>
    </div>;
}